export interface CustomerServiceStatusOption {
  value: number;
  label: string;
}

/** Dataverse choice values for cr001_customer_serviceses.cr001_status */
export const SERVICE_STATUS_ACTIVE = 468190000;
export const SERVICE_STATUS_INACTIVE = 468190001;
export const SERVICE_STATUS_ONBOARDING = 468190002;
export const SERVICE_STATUS_TO_BE_DEACTIVATED = 468190003;
export const SERVICE_STATUS_SUSPENDED = 468190004;

export const CUSTOMER_SERVICE_STATUS_OPTIONS: CustomerServiceStatusOption[] = [
  { value: SERVICE_STATUS_ACTIVE, label: 'Active' },
  { value: SERVICE_STATUS_INACTIVE, label: 'Inactive' },
  { value: SERVICE_STATUS_SUSPENDED, label: 'Suspended' },
  { value: SERVICE_STATUS_ONBOARDING, label: 'Onboarding' },
];
